var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 2 };
const _hoisted_2 = { class: "title" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "mt-2" };
const _hoisted_5 = ["value"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_7 = { key: 4 };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("strong", null, "You have successfully registered! We will contact you via email once we have checked and approved your registration.", -1);
const _hoisted_9 = [
    _hoisted_8
];
import { doApiAction } from "@/core/api";
import { CONFIG } from "@/core/config";
import { onMounted, ref, watch } from "vue";
import { apiPartnerOnboarding } from "../api";
import PartnerOnboardingFormDocumentsPage from "./PartnerOnboardingFormDocumentsPage.vue";
import PartnerOnboardingFormProfilePage from "./PartnerOnboardingFormProfilePage.vue";
import PartnerOnboardingFormTermsPage from "./PartnerOnboardingFormTermsPage.vue";
import PartnerOnboardingFormTutorialsPage from "./PartnerOnboardingFormTutorialsPage.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerOnboardingForm',
    props: {
        invite: {}
    },
    setup(__props) {
        const props = __props;
        const savedStateLoading = ref(true);
        const formState = ref({
            request: {
                admin: {
                    email: "",
                    phone: "",
                    displayName: "",
                    jobTitle: "",
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    address: {
                        number: "",
                        street: "",
                        city: "",
                        state: "GA",
                        postalCode: "",
                        country: "United States"
                    },
                    workBadge: undefined,
                    stateId: undefined,
                    signature: undefined,
                },
                siteNames: [],
                logo: undefined,
            },
            viewedTerms: [],
            viewedTutorials: [],
            activePage: 'profile',
        });
        const pageProgressAmounts = {
            'profile': 15,
            'documents': 50,
            'terms': 75,
            'tutorials': 90
        };
        onMounted(() => {
            const savedState = localStorage[`partnerOnboarding.partner.${props.invite.id}`];
            if (savedState) {
                const savedStateJson = JSON.parse(savedState);
                if (savedStateJson && savedStateJson.activePage != 'completed') {
                    console.log("Loaded form state", savedStateJson);
                    formState.value = savedStateJson;
                }
            }
            savedStateLoading.value = false;
        });
        const inProgressAction = ref(null);
        watch([formState], () => {
            localStorage[`partnerOnboarding.partner.${props.invite.id}`] = JSON.stringify(formState.value);
        }, { deep: true });
        const proceedTo = (page) => {
            formState.value.activePage = page;
            window.scrollTo(0, 0);
        };
        const submitForm = () => {
            doApiAction(inProgressAction, 'submitForm', "Successfully registered!", "Failed to register", () => __awaiter(this, void 0, void 0, function* () {
                yield apiPartnerOnboarding.createPartner(props.invite, formState.value.request);
                formState.value.activePage = 'completed';
            }));
        };
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            return (savedStateLoading.value)
                ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                : (inProgressAction.value == 'submitForm')
                    ? (_openBlock(), _createBlock(_component_LoadingPage, {
                        key: 1,
                        label: "Please Wait..."
                    }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", null, [
                            _createElementVNode("h1", _hoisted_2, "Welcome to " + _toDisplayString(_unref(CONFIG).networkName) + "!", 1),
                            (formState.value.activePage != 'completed')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("h3", null, [
                                        _createTextVNode("This form is for directors and administrators of "),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.invite.name), 1),
                                        _createTextVNode(" to fill out as part of our onboarding process.")
                                    ]),
                                    _createElementVNode("h3", _hoisted_4, [
                                        _createTextVNode("If you have any questions about the form, please contact "),
                                        _createElementVNode("strong", null, _toDisplayString(_unref(CONFIG).helpEmail), 1)
                                    ]),
                                    _createElementVNode("progress", {
                                        class: "progress is-primary mt-5",
                                        value: pageProgressAmounts[formState.value.activePage],
                                        max: "100"
                                    }, null, 8, _hoisted_5)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _hoisted_6,
                        (formState.value.activePage == 'profile')
                            ? (_openBlock(), _createBlock(PartnerOnboardingFormProfilePage, {
                                key: 0,
                                modelValue: formState.value.request,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formState.value.request) = $event)),
                                onProceed: _cache[1] || (_cache[1] = ($event) => (proceedTo('documents')))
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        (formState.value.activePage == 'documents')
                            ? (_openBlock(), _createBlock(PartnerOnboardingFormDocumentsPage, {
                                key: 1,
                                modelValue: formState.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formState).value = $event)),
                                onBack: _cache[3] || (_cache[3] = ($event) => (proceedTo('profile'))),
                                onProceed: _cache[4] || (_cache[4] = ($event) => (proceedTo('terms')))
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        (formState.value.activePage == 'terms')
                            ? (_openBlock(), _createBlock(PartnerOnboardingFormTermsPage, {
                                key: 2,
                                modelValue: formState.value.viewedTerms,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((formState.value.viewedTerms) = $event)),
                                terms: _unref(CONFIG).partnerOnboarding.partner.terms,
                                onBack: _cache[6] || (_cache[6] = ($event) => (proceedTo('documents'))),
                                onProceed: _cache[7] || (_cache[7] = ($event) => { formState.value.request.admin.signature = $event; proceedTo('tutorials'); })
                            }, null, 8, ["modelValue", "terms"]))
                            : _createCommentVNode("", true),
                        (formState.value.activePage == 'tutorials')
                            ? (_openBlock(), _createBlock(PartnerOnboardingFormTutorialsPage, {
                                key: 3,
                                modelValue: formState.value.viewedTutorials,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((formState.value.viewedTutorials) = $event)),
                                tutorials: _unref(CONFIG).partnerOnboarding.partner.tutorials,
                                onBack: _cache[9] || (_cache[9] = ($event) => (proceedTo('terms'))),
                                onProceed: _cache[10] || (_cache[10] = ($event) => (submitForm()))
                            }, null, 8, ["modelValue", "tutorials"]))
                            : _createCommentVNode("", true),
                        (formState.value.activePage == 'completed')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_9))
                            : _createCommentVNode("", true)
                    ]));
        };
    }
});
